export const createCustomAttributes = (typeOfAttr:string, attrData: string[]) => {

	if(typeOfAttr === "ManuFacturer" && attrData?.length === 4){
		return {"Fabrikant naam:":attrData[1],"Fabrikant adres:":attrData[2],"Fabrikant contact:":attrData[3]};
	}
	if(typeOfAttr === "Supplier" && attrData?.length === 4){
		return {"naam:":attrData[1],"adres:":attrData[2],"contact:":attrData[3]};
	}
}